import React,{ useState,useEffect/* ,useRef */ } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../components/recoil/atoms/Menus";

import HeaderBranchTitle from "./components/includes/HeaderBranchTitle";
import AttendanceChildrens from "./components/popups/AttendanceChildrens";
import { ChangeSearchingDateFormat,PassedMonthsCode,GetMonthCalendar,isNull,GetWeekIndex,GetClassStatus,GetDateWeeksString,
        SetSelectedDateState,LoginAfterCheckLogin,ToggleDarkBackground } from "../components/common/Common";

import 'swiper/css';

import main01Icon from "../img/icon/icon-center-main01.svg";
import class01Icon from "../img/icon/icon-class01.svg";
import class02Icon from "../img/icon/icon-class02.svg";
import kidsIcon from "../img/icon/icon-view-kids.svg";
import arrowIcon from "../img/icon/icon-arrow-right-g.svg";
import addClassIcon from "../img/icon/icon-add-sc.svg";

const MainBranch = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검
  const branch_idx = Number(localStorage.getItem('branch_idx'));
  const navigate = useNavigate();

  //const swiperRef = useRef(null);
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  //메인페이지 변수 정의
  const [varClassType,setClassType] = useState(1);      //클래스 타입
  const [varClassRoom,setClassRoom] = useState(1);      //클래스룸 타입
  const [varClassRoomList,setClassRoomList] = useState([]); //전체 클래스룸 배열
  const [varSelectClassRoomList,setSelectClassRoomList] = useState([]); //선택된 클래스타입에 해당하는 교실 배열

  //학기
  const [varSemesterIndex,setSemesterIndex] = useState(0);
  const [varSemesterList,setSemesterList] = useState([]);

  const [varCurrentMonth,setCurrentMonth] = useState(null);  //선택된 월
  const [varCurrentDate,setCurrentDate] = useState(null);  //선택된 날짜
  const [varWeekList,setWeekList] = useState([]);  //해당월의 달력 - 주단위
  const [varShowDaysList,setShowDaysList] = useState([]);  //해당월의 달력 - 주단위
  const [varCurrentWeekIndex,setCurrentWeekIndex] = useState(-1);

  //선택년월 (1년전~1년후))
  const [varYearMonthList,setYearMonthList] = useState([]); 

  //해당조건에 맞는 클래스 내역 정보 
  const [varClassList,setClassList] = useState([]);

  //해당조건에 맞는 클래스 내역 정보 
  const [varPageStartMode,setPageStartMode] = useState(true);

  //클래스룸 호출
  const GetClassroomList = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_classes_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //학기
        if(datas.semesters.length > 0){
          setSemesterList(datas.semesters); 
        } 
        //교실
        if(datas.classroom.length > 0){
          setClassRoomList(datas.classroom);
          console.log(Number(localStorage.getItem('class_room')));
          if(Number(localStorage.getItem('class_room')) === 0) SetClassRoomList();
        } 
      }
    });
  }

  //최초 로딩시
  useEffect(() => {
    //제목부 지정
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:-1});

    //오늘날짜를 선택날짜로 지정
    let displayDate = new Date();
    if(!isNull(localStorage.getItem('mainDate'))){
      const ldate = localStorage.getItem('mainDate');
      console.log(ldate);
      displayDate = new Date(ldate);
    } 
    setCurrentDate(displayDate);

    //선택된 날짜에서 선택년월로 지정
    const curMonth = displayDate.getFullYear() + '.'+ ('0' + (displayDate.getMonth() + 1)).slice(-2);
    console.log(curMonth);
    setCurrentMonth(curMonth);

    //1년전~1년후 년.월 배열 만들기
    let monthArray = [];
    let nyear = new Date(displayDate);
    nyear.setMonth(nyear.getMonth()-12);
    for(var i=0; i < 24; i++) {
      const bdate = new Date(nyear.setMonth(nyear.getMonth() + 1));
      const bmonth = bdate.getFullYear() + '.'+ ('0' + (bdate.getMonth() + 1)).slice(-2);
      monthArray.push(bmonth);
    }
    setYearMonthList(monthArray);

    //현재 사용중인 학기가 존재하면
    if(!isNull(localStorage.getItem('semesterIndex'))) {
      setSemesterIndex(Number(localStorage.getItem('semesterIndex')));
    }
    //클래스 교육 형식 :마마몽뗴/플라이
    if(isNull(localStorage.getItem('class_type'))) setClassType(1);
    else setClassType(Number(localStorage.getItem('class_type')));
    //교실
    if(!isNull(localStorage.getItem('class_room'))){
      setClassRoom(Number(localStorage.getItem('class_room')));
    }

    //전체 클래스 교실 목록 호출
    GetClassroomList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //클래스 타입변경시
  useEffect(() => {
    if(varClassRoomList.length > 0) SetClassRoomList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassType,varClassRoomList]);

  //클래스 학습룸 배열 재조정
  const SetClassRoomList = () => {
    const classroomList = varClassRoomList.filter(el => el.cr_type === varClassType);
    if(classroomList.length > 0) {
      setSelectClassRoomList(classroomList);
      if(!varPageStartMode && isNull(localStorage.getItem('class_room'))){
        setClassRoom(classroomList[0].cr_idx);
        localStorage.setItem('class_room',classroomList[0].cr_idx);
      }
      setPageStartMode(false);
    }
  }

  //클래스 내역 검색
  const GetClassList = async() => {
    const sdbdate = ChangeSearchingDateFormat(varCurrentDate,'-');
    const sendData = {branch_idx:branch_idx,sm_idx:varSemesterIndex,cl_type:varClassType,cr_idx:varClassRoom,sdate:sdbdate};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_main_class_List`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const classList = datas.results;
        if(classList.length > 0) GetChildrenList(classList);
        else setClassList([]);
      }
    });
  }

  //클래스 내역별 원생 목록 추가
  const GetChildrenList = async(classList) => {
    const sdbdate = ChangeSearchingDateFormat(varCurrentDate,'-');
    for(var i=0; i < classList.length; i++) {
      const classData = classList[i];
      classData.childrens = [];
      let childrenArray = [];
      const sendData = {cl_idx:classData.cs_cl_idx,sdate:sdbdate};
      console.log(sendData);
      await axios.post(`${process.env.REACT_APP_HOST}/branch_get_main_children_List`,sendData).then((res) => {
        const datas = res.data;
        console.log(datas);
        if(datas.retvalue === 1) {
          const childrens = datas.results;
          for(var j=0; j < childrens.length; j++) {
            let childData = childrens[j];
            let newData = {idx:childData.ch_idx,clidx:childData.csc_cl_idx,cidx:childData.csc_idx,csidx:childData.cs_idx,name:childData.ch_name,
                      months:PassedMonthsCode(childData.ch_birthday),state:childData.clc_status,cstate:childData.csc_status};
            childrenArray.push(newData);
          }
          console.log(childrenArray);
        }
      });
      classData.childrens = childrenArray;
      classList[i] = classData;
    }
    setClassList(classList);
  }

  //클래스룸 변경시
  useEffect(() => {
    //console.log(varClassRoom,varCurrentDate,varWeekList.length);
    if(/* varClassRoom > 0 &&  */!isNull(varCurrentDate) && varWeekList.length > 0) {
      let iday = varCurrentDate.getDate();
      let newArray = SetSelectedDateState(iday,varWeekList);
      setWeekList(newArray);
      GetClassList();
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varClassRoom,varCurrentDate,varWeekList,varSemesterIndex]);

  //갬색일을 오늘로
  const onChangeTodayHandler = (e) => {
    const today = new Date();
    const curMonth = today.getFullYear() + '.'+ ('0' + (today.getMonth() + 1)).slice(-2);

    if(curMonth !== varCurrentMonth) {
      setCurrentMonth(curMonth);
      setCurrentWeekIndex(-1);
    } else {
      const iday = today.getDate();
      const weekIndex = GetWeekIndex(iday,varWeekList);
      setCurrentWeekIndex(weekIndex);
    }
    setCurrentDate(today);
  }

  //월변경시
  useEffect(() => {
    if(!isNull(varCurrentMonth)) {
      //선택날짜의 해당월에 대하 달력 생성
      const weeksArray = GetMonthCalendar(varCurrentMonth);
      setWeekList(weeksArray);

      console.log(varCurrentWeekIndex,varCurrentDate.getDate(),weeksArray);
      if(varCurrentWeekIndex === -1) {
        const iday = varCurrentDate.getDate();
        const weekIndex = GetWeekIndex(iday,weeksArray);
        setCurrentWeekIndex(weekIndex);
      } else {
        setCurrentWeekIndex(0);
      }
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varCurrentMonth]);

  useEffect(() => {
    if(varWeekList.length > 0 && varCurrentWeekIndex >= 0) {
      //보여줄 주간의 날짜 배열
      const showArray = varWeekList[varCurrentWeekIndex];
      setShowDaysList(showArray);
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varCurrentWeekIndex]);

  //검색월을 변경
  const onChangeMonthHandler = (e) => {
    const smonth = e.currentTarget.value;
    setCurrentMonth(smonth);
  }

  //한주씩 swiper
  const onChangeNextWeekHandler = (e,iweek) => {
    let newIndex = varCurrentWeekIndex + iweek;
    console.log(varCurrentWeekIndex,iweek);
    if(newIndex < 0 || newIndex >= varWeekList.length) {
      const newDate = new Date(varCurrentMonth+'.01');
      newDate.setMonth(newDate.getMonth() + iweek);
      const newMonth = newDate.getFullYear() + '.'+ ('0' + (newDate.getMonth() + 1)).slice(-2);
      setCurrentMonth(newMonth);
    } else {
      setCurrentWeekIndex(newIndex);
    }
  }

  //날짜 선택시
  const onSelectDateHandler = (e,iday) => {
    const cDate = varCurrentMonth.replace('.','-')+'-'+('0' + iday).slice(-2);
    console.log(cDate);
    const sdate = new Date(cDate);
    console.log(sdate);
    localStorage.setItem('mainDate',cDate);
    setCurrentDate(sdate);
  }

  //클래스 생성
  const onAddClassHandler = (e) => {
    localStorage.setItem('backPageUrl','/MainBranch');
    navigate('/Branch/ClassDetail/0');
  }

  //학기선택
  const onSelectSemesterIndex = (e) => {
    const sm_idx = Number(e.currentTarget.value);
    localStorage.setItem('semesterIndex',sm_idx);
    setSemesterIndex(sm_idx);
  }

  //클래스 타입 교체
  const onChangeClassTypeHandler = (e,itype) => {
    localStorage.setItem('class_type',itype);
    setClassType(itype);
    setClassRoom(0);
  }

  //클래스룸 변경
  const onChangeClassroomHandler = (e,cr_idx) => {
    console.log(cr_idx);
    localStorage.setItem('class_room', cr_idx);
    setClassRoom(cr_idx);
  }

  //클래스 수업 내역 보기
  const onClassInformationHandler = (e,cl_idx,cl_mode) => {
    localStorage.setItem('backPageUrl','/MainBranch');
    localStorage.setItem('class_information',cl_mode-1);
    navigate(`/Branch/ClassInformation/${cl_idx}`);
  }

  //클래스별 원생 출/결석 체크
  const [varPopupAttendanceChildrens,setPopupAttendanceChildrens] = useState(false);
  const [varChildrenList,setChildrenList] = useState([]);
  const onAttendanceChildrenHandler = (e,childrens) => {
    setChildrenList(childrens);
    ToggleDarkBackground(true);
    setPopupAttendanceChildrens(true);
  }
  const onCloseAttendanceChildrenHandler = (e) => {
    ToggleDarkBackground(false);
    setPopupAttendanceChildrens(false);
  }

  return (
    <div className="vh-content center-main">
      <HeaderBranchTitle varPageTitle="클래스 현황" varBackString="none"/>
      <div className="center-wrap">
        <div className="vh-content-body">
          {/* 학기 선택 */}
          <div className="sem-select-wrap">
            <label>학기 선택</label>
            <select name="" value={varSemesterIndex} onChange={e=>onSelectSemesterIndex(e)}>
              <option value={0}>전체 학기</option>
              {varSemesterList.map((semester,i)=>(
                <option key={'semester_'+i} value={semester.sm_idx}>{semester.sm_name}</option>
              ))}
            </select>
          </div>
          {/* 클래스 타입 선택 - 마마몽떼/플라이 */}
          <div className="tab-wrap" style={{marginTop:"30px"}}>
            <ul>
              <li className={varClassType===1?"active":""} onClick={e=>onChangeClassTypeHandler(e,1)}><div>마마몽떼</div></li>
              <li className={varClassType===2?"active":""} onClick={e=>onChangeClassTypeHandler(e,2)}><div>플라이</div></li>
            </ul>
          </div>
          {/* 클래스타입별 교실 선택 */}
          <div className="btn-class-wrap">
            <ul>
              {varSelectClassRoomList.map((croom,i)=>(
                <li key={'croom_'+i} className={croom.cr_idx===varClassRoom?"active":""} onClick={e=>onChangeClassroomHandler(e,croom.cr_idx)}>
                  <div>{croom.cr_name}</div>
                </li>
              ))}
            </ul>
          </div>
          {/* 검색할 날짜 선택 */}
          <div className="date-wrap">
            <select name="curMonth" value={varCurrentMonth||""} onChange={e=>onChangeMonthHandler(e)}>
              {varYearMonthList.map((yearMonth,i)=>(
                <option key={'yearMonth_'+i} value={yearMonth}>{yearMonth}</option>
              ))}
            </select>
            <button className="btn-today" onClick={e=>onChangeTodayHandler(e)}>오늘보기</button>
          </div>
          {/* 검색된 클래스 내역 */}
          <div className="week-swiper-wrap">
            <div className="swiper-container">
              <Swiper spaceBetween={0} slidesPerView={7}>
                {varShowDaysList.map((day, i) => (
                  day.date === 0? 
                    <SwiperSlide key={'day_'+i} className="swiper-slide">
                      <div className="week-card">
                        <div className="text"></div>
                        <div className="num"></div>
                      </div>
                    </SwiperSlide>
                  :
                    <SwiperSlide key={'day_'+i} className="swiper-slide">
                      <div className={day.select===1?"week-card current":day.week==="토"?"week-card sat":day.week==="일"?"week-card sun":"week-card"} onClick={e=>onSelectDateHandler(e,day.date)}>
                        <div className="text">{day.week}</div>
                        <div className="num">{day.date}</div>
                      </div>
                    </SwiperSlide>
                ))}
              </Swiper>
              <div className="swiper-button-prev week-swiper-prev" onClick={e=>onChangeNextWeekHandler(e,-1)}></div>	
              <div className="swiper-button-next week-swiper-next" onClick={e=>onChangeNextWeekHandler(e,1)}></div>
            </div>
          </div>
          {/* 클래스 내역 */}
          <div className="class-list">
            <ul>
              {varClassList.map((classes,i)=>(
                <li key={'classes_'+i}>
                  <div className="class-card-top">
                    <div className="left">
                      <img src={main01Icon} alt=""/>
                      <span>{classes.cl_type===1?"마마몽떼":"플라이"}<br/>{classes.cr_name}</span>
                    </div>
                    <div className="right">
                      <div className="line">
                        <img src={class01Icon} alt="" />
                        <p>{GetDateWeeksString(classes.cs_date)} {classes.cs_hour}:{classes.cs_minute}</p>
                      </div>
                      <div className="line">
                        <img src={class02Icon} alt="" />
                        <p>{classes.cl_name}</p>
                      </div>
                      <div className="line">
                        <img src={kidsIcon} alt="" />
                        <p>{classes.entrys}명</p>
                      </div>
                    </div>
                    <div className="btn-setting" onClick={e=>onClassInformationHandler(e,classes.cl_idx,classes.cl_mode)}><img src={arrowIcon} alt="" /></div>
                  </div>
                  <div className="class-card-bottom">
                    <ul onClick={e=>onAttendanceChildrenHandler(e,classes.childrens)}>
                      {classes.childrens.map((childs,j)=>(
                        <li key={'childs_'+j} className={GetClassStatus(childs.state)}>{`${childs.name}(${childs.months})`}</li>
                      ))}
                    </ul>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <AttendanceChildrens varPopupAttendanceChildrens={varPopupAttendanceChildrens} 
            onCloseAttendanceChildrenHandler={onCloseAttendanceChildrenHandler} varChildrenList={varChildrenList} setChildrenList={setChildrenList}/>
          <button className="btn-add" onClick={e=>onAddClassHandler(e)}><img src={addClassIcon} alt="" />클래스 생성</button>
        </div>
      </div>
    </div>
  )
}
export default MainBranch;